// extracted by mini-css-extract-plugin
export var actionIcon = "_sb-0";